import { httpClient } from '@/services/http/httpClient'

export async function toggleStatus(id: string): Promise<void> {
  await httpClient.patch(`/users/${id}/status`)
}
